import $ from "jquery";
window.$ = window.jQuery = $;

(function ($) {
  $(".header_btn-burger").click(function () {
    $(".header_menu").addClass("open");
  });
  $(".header_menu__close").click(function () {
    $(".header_menu").removeClass("open");
  });
  $(document).mouseup(function (e) {
    var header_menu = $(".header_menu__wrap");
    if (!header_menu.is(e.target) && header_menu.has(e.target).length === 0) {
      $(".header_menu").removeClass("open");
    }
  });
  $(".search-trigger").click(function () {
    $(".header_search").toggleClass("open");
  });
  $(".search-close").click(function () {
    $(".header_search").removeClass("open");
  });
  $(document).mouseup(function (e) {
    var search_field = $(".search-field input");
    if (!search_field.is(e.target) && search_field.has(e.target).length === 0) {
      $(".header_search").removeClass("open");
    }
  });

  $("img.img-svg").each(function () {
    var $img = $(this);
    var imgClass = $img.attr("class");
    var imgURL = $img.attr("src");
    $.get(
      imgURL,
      function (data) {
        var $svg = $(data).find("svg");
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " replaced-svg");
        }
        $svg = $svg.removeAttr("xmlns:a");
        if (
          !$svg.attr("viewBox") &&
          $svg.attr("height") &&
          $svg.attr("width")
        ) {
          $svg.attr(
            "viewBox",
            "0 0 " + $svg.attr("height") + " " + $svg.attr("width"),
          );
        }
        $img.replaceWith($svg);
      },
      "xml",
    );
  });

  $(".view-pass").click(function () {
    $(this).addClass("active").siblings("input").attr("type", "text");
  });

  $(".coupon_copy").click(function () {
    let $temp = $("<input>");
    let text = $(this).siblings(".coupon_text");
    $("body").append($temp);
    $temp.val(text.text()).select();
    document.execCommand("copy");
    $temp.remove();
    $(this)
      .parents(".modal")
      .find(".modal_notification")
      .addClass("visible success");
  });

  // modals ==================
  function modal() {
    // Open Modal
    $(".btn--modal").on("click", function (e) {
      e.preventDefault();
      let target = "#" + $(this).data("target");
      $("body").addClass("no-scroll");
      $(".modal").removeClass("open");
      $(target).addClass("open");
    });

    // close modal
    $(".modal_close").click(function () {
      $(".modal").removeClass("open");
      $("body").removeClass("no-scroll");
      $(".modal_notification").removeClass("visible");
    });
    $(".modal_notification .close").click(function () {
      $(".modal_notification").removeClass("visible");
    });
  }
  modal();

  function accordion() {
    $(".accordion_item").each(function () {
      let ths = $(this);
      let title = $(this).find(".accordion_title");
      let content = $(this).find(".accordion_content");
      title.click(function () {
        $(this).toggleClass("active");
        content.slideToggle(240);
        ths.siblings().find(".accordion_content").slideUp(240);
        ths.siblings().find(".accordion_title").removeClass("active");
      });
    });
  }
  accordion();

  $(".header_user").click(function () {
    $(this).toggleClass("open");
  });
  $(document).mouseup(function (e) {
    var header_user = $(".header_user");
    if (!header_user.is(e.target) && header_user.has(e.target).length === 0) {
      header_user.removeClass("open");
    }
  });

  function rating() {
    $(".rating--add").on("click", ".img-svg", function () {
      let count = $(this).index() + 1;
      $(".rating--add").attr("data-rating", count);
      $(".rating-result_count").text(count);
    });
    $(".rating--published").each(function () {
      var rating = parseFloat($(this).data("rating")) || 0;
      var hiddenPercent = (5 - rating) * 20;
      $(this).css("--rating-width", hiddenPercent + "%");
    });
  }
  rating();

  function reviewPublished() {
    $(".review_published").each(function () {
      let ths = $(this);
      let openField = ths.find(".item.reply");
      let closeField = ths.find(".btn--replpy-cancel");
      let reviewField = ths.find(".review_reply__field");
      openField.click(function () {
        reviewField.show(250);
        $("html, body").animate(
          {
            scrollTop: reviewField.offset().top - 100,
          },
          500,
        );
      });
      closeField.click(function () {
        reviewField.hide(250);
      });
    });
  }
  reviewPublished();

  $(".more-trigger").click(function () {
    $(this)
      .parents(".casino-card--bonuse")
      .toggleClass("open-more")
      .siblings(".casino-card--bonuse")
      .removeClass("open-more");
  });
  $(document).mouseup(function (e) {
    let casinoBonuseCart = $(".casino-card--bonuse");
    if (
      !casinoBonuseCart.is(e.target) &&
      casinoBonuseCart.has(e.target).length === 0
    ) {
      casinoBonuseCart.removeClass("open-more");
    }
  });

  function select() {
    $(".select_title").click(function () {
      $(this).parents(".select").toggleClass("open");
    });
    $(document).mouseup(function (e) {
      let select = $(".select");
      if (!select.is(e.target) && select.has(e.target).length === 0) {
        select.removeClass("open");
      }
    });
    $(".select button").click(function () {
      $(this).toggleClass("active");
    });
    $(".select_clear").click(function () {
      $(this).parents(".select").find("button").removeClass("active");
    });
  }
  select();

  // submenu
  $(".header_nav .menu-item-has-children").click(function () {
    $(this).toggleClass("open");
  });

  $(document).ready(function () {
    $(".project_descript table").each(function () {
      if (!$(this).parent().is("figure.wp-block-table")) {
        $(this).wrap('<figure class="wp-block-table"></figure>');
      }
    });
  });
})(jQuery);
